import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=27520318&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=27520318&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27520318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27520318')) {
      api.createRecord('27520318', component.options)
    } else {
      api.reload('27520318', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=27520318&scoped=true", function () {
      api.rerender('27520318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderManage/orderDetail.vue"
export default component.exports